"use client";

import Flex from "@/shared/components/common/Flex";
import Skeleton from "@/shared/components/common/Skeleton";
import Separator from "@/shared/components/common/separator";
import Grid from "@/shared/components/common/Grid";
import List from "@/shared/components/common/List";
import { createNewArray } from "@/shared/libs/array-utils";

export default function ConfirmSkeleton() {
  return (
    <Grid className="w-full grid-cols-12 gap-y-4">
      <List
        items={createNewArray(4, 0)}
        renderItems={() => (
          <Grid.GridCol className="col-start-2 col-end-12 max-sm:col-start-1 max-sm:col-end-13">
            <Flex className="flex-col bg-background rounded-xs px-4">
              <Flex className="py-4 gap-x-4 items-center">
                <Skeleton className="w-5 h-5" />
                <Skeleton className="w-36 h-2" />
              </Flex>

              <Separator direction="horizontal" className="bg-muted!" />

              <Grid className="grid-cols-2 py-10">
                <Grid.GridCol className="col-span-full">
                  <Flex className="flex-col gap-y-4 px-8 items-center">
                    <Flex className="w-full hidden max-sm:flex flex-col gap-y-2">
                      <List
                        items={createNewArray(4, 0)}
                        renderItems={() => (
                          <Flex className="w-full flex-col gap-y-2">
                            <Flex className="justify-between">
                              <Skeleton className="w-16 h-2" />
                              <Skeleton className="w-16 h-2" />
                            </Flex>
                          </Flex>
                        )}
                      />
                    </Flex>

                    <Flex className="w-full flex-col justify-center items-center gap-y-2 max-sm:hidden">
                      <Skeleton className="w-2/3 h-8 rounded-xs" />
                      <Skeleton className="w-2/3 h-8 rounded-xs" />
                    </Flex>
                  </Flex>
                </Grid.GridCol>
              </Grid>
            </Flex>
          </Grid.GridCol>
        )}
      />
    </Grid>
  );
}
